<template>
  <div class="">
    <h3 class="pt-0 mt-0 pb-0">{{ $t('viewSettings.pricemarkups.title') }}</h3>
    <v-card class="mt-2" elevation="0" :loading="!suppliersIsFetched || !storagesIsFetched || !pricemarkupsIsFetched || (!fetched && $route.params.id)">
        <v-form ref="pricemarkupsForm">
          <v-row class="px-0">
            <v-col sm="12" md="3" cols="12">
              <v-select
                  outlined
                  hide-details
                  :items="types"
                  :label="$t('viewSettings.pricemarkups.source')"
                  :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                  item-text="name"
                  return-object
                  v-model="currentPricemarkup.type_object"
              >
                <template v-slot:item="{item}">
                  {{ item.name }}
                </template>
                <template v-slot:selection="{item}">
                  {{ item.name }}
                </template>
              </v-select>
            </v-col>
            <v-col sm="12" md="3" cols="12">
              <v-text-field
                outlined
                hide-details
                v-if="fetched || !!this.$route.params.id"
                :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                :value="currentPricemarkup.from_price"
                v-model="currentPricemarkup.from_price"
                :label="$t('viewSettings.pricemarkups.from_price')"
              ></v-text-field>
            </v-col>
            <v-col sm="12" md="3" cols="12">
              <v-text-field
                outlined
                hide-details
                v-if="fetched || !!this.$route.params.id"
                :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                :value="currentPricemarkup.to_price"
                v-model="currentPricemarkup.to_price"
                :label="$t('viewSettings.pricemarkups.to_price')"
              ></v-text-field>
            </v-col>
            <v-col sm="12" md="3" cols="12">
              <v-text-field
                outlined
                hide-details
                v-if="fetched || !!this.$route.params.id"
                :rules="[(v) => !!v || $t('form.validationErrors.field_is_required')]"
                :value="currentPricemarkup.value"
                v-model="currentPricemarkup.value"
                :label="$t('viewSettings.pricemarkups.title')"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-divider></v-divider>
          <v-spacer></v-spacer>
          <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5 white--text mr-4"
              elevation="0"
              color="red"
              @click="$router.push({name: 'settings-pricemarkups'});"
              @keyup.enter="$router.push({name: 'settings-pricemarkups'});"
          >
            {{ $t('common.cancel') }}
          </v-btn>
          <v-btn
              :disabled="savingInProgress"
              :loading="savingInProgress"
              class="mt-5"
              elevation="0"
              color="primary"
              @click="submit"
              @keyup.enter="submit"
          >
            {{ $t('common.save') }}
          </v-btn>
        </v-form>

    </v-card>
  </div>
</template>
<script>
import {required, email, sameAs, minLength,} from "vuelidate/lib/validators";
import {mapState} from 'vuex';
import {mapFields, mapMultiRowFields} from 'vuex-map-fields';
import PricemarkupMixin from "@/mixins/pricemarkup";
export default {
  mixins: [PricemarkupMixin],
  data: () => ({
    currentPricemarkup: {
      from_price: null,
      to_price: null,
      value: null,
      type_object: {
        name: null,
        type: null,
        type_value: null
      }
    }
  }),
  created() {
    this.onLoad();
  },

  watch: {
    '$route'(to, from) {
      this.onLoad();
    }
  },
  computed: {
    ...mapFields('storages', {'storagesIsFetched':'fetched'}),
    ...mapFields('suppliers', {'suppliersIsFetched':'fetched'}),
    ...mapFields('pricemarkups', {'pricemarkupsIsFetched':'fetched'}),
    ...mapFields('pricemarkups', [
      'savingInProgress',
      'fetched'
    ]),
    ...mapMultiRowFields('pricemarkups', [
      'pricemarkups',
    ]),

  },
  methods: {
    onLoad() {
      this.$store.dispatch('suppliers/get').then(()=>{
          this.$store.dispatch('storages/get').then(()=>{

            if (this.$route.params.id > 0) {
              this.$store.dispatch('pricemarkups/get').then(() => {
                let one = (this.pricemarkups.find(item => Number(item.id) === Number(this.$route.params.id)))
                if (one) {
                  let source = this.types.find((cur)=>{
                    return one.type === cur.type && String(one.type_value) === String(cur.type_value);
                  });
                  this.currentPricemarkup = {
                    type_object: source,
                    from_price: one.from_price,
                    to_price: one.to_price,
                    value: one.value,
                    id: one.id
                  };
                } else {
                  this.$router.push({name: '404'})
                }
              });
            }
          })
      })
    },
    submit() {
      if (this.$refs['pricemarkupsForm'].validate()) {
        if (this.$route.params.id > 0) {
          let tmp = JSON.parse(JSON.stringify(this.currentPricemarkup));
          this.$store.dispatch('pricemarkups/update', this.currentPricemarkup).then((id) => {
            if (id > 0) {
              this.$router.push({name: 'settings-pricemarkups'});
            }
          })
        } else {
          this.$store.dispatch('pricemarkups/store', this.currentPricemarkup).then((id) => {
            if (id > 0) {
              this.$router.push({name: 'settings-pricemarkups'});
            }
          })
        }
      }
    }
  },
}
</script>